const BACKEND_BASE = process.env.NEXT_PUBLIC_BACKEND_BASE;

const isImage = object => object?.mime?.startsWith('image/');

/**
 * Recursively changes the image URL in the given object and its nested objects.
 *
 * @param {Object} object - the object to traverse and update image URLs
 * @param {string} key - the key of the current object field
 * @param {Object} parent - the parent object of the current object
 */
export default function changeImageUrl(object = {}, key = '', parent = {}) {
  if (!object) return;

  if (object?.mime && object?.url?.startsWith('/')) {
    //if it is an image, keep an object
    if (isImage(object)) {
      object.url = BACKEND_BASE + object.url;
    }

    //if not, transform the object into an image url
    if (key && !isImage(object)) {
      parent[key].url = BACKEND_BASE + object.url;
    }
  }

  if (object && Array.isArray(object)) {
    for (let i = 0; i < object.length; i++) {
      changeImageUrl(object[i], `${i}`, object);
    }
  }

  if (typeof object === 'object') {
    for (const key in object) {
      changeImageUrl(object[key], key, object);
    }
  }
}
